import { render } from "./basicConfirmModal.vue?vue&type=template&id=ae7d7ad2"
import script from "./basicConfirmModal.vue?vue&type=script&lang=js"
export * from "./basicConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__